<!--
 - App component
 -
 - @author Jenny Lam <jlam@buildcentrix.com>
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 -
 - @copyright (c) 2025 Build Centrix
 -->
<!--Layout and Content-->
<div class="App" [ngClass]="{'is__shown': isInitialized}">
  <bc-templates-layout>
    <div header-content>
      <bc-organisms-header
        [user]="userInformation"
        [environment]="environmentValues"
      ></bc-organisms-header>
    </div>
    <div sidebar-content>
      <bc-organisms-sidebar [isToggled]="true">
        <div sidebar-links>
          <!--Work Orders-->
          <bc-molecules-sidebar-item
            label="{{'order.types.work.title'|translate}} {{'order.title.plural'|translate}}"
            type="workOrders"
            link="./orders/list/work"
            *ngIf="environmentValues.permissions.canViewWorkOrders()"
          ></bc-molecules-sidebar-item>
          <!--Spooling Orders-->
          <bc-molecules-sidebar-item
            label="{{'order.types.lookahead.title'|translate}} {{'order.title.plural'|translate}}"
            type="lookaheadOrders"
            link="./orders/list/lookahead"
            *ngIf="environmentValues.permissions.canViewLookaheadOrders()"
          ></bc-molecules-sidebar-item>
          <!--Vehicle Assignment-->
          <bc-molecules-sidebar-item
            label="{{'order.shipping.vehicle.assignment.title'|translate}}"
            type="shippingVehicle"
            link="./shipping/drivers/assignment"
            *ngIf="environmentValues.permissions.canViewVehicleAssignments()"
          ></bc-molecules-sidebar-item>
        </div>
      </bc-organisms-sidebar>
    </div>
    <div main-content>
      <router-outlet></router-outlet
      ><!-- ng2+ route content -->
    </div>
  </bc-templates-layout>
</div>
<!--Loader-->
<bc-atoms-loader
  *ngIf="!isInitialized"
  [title]="('actions.loading'|translate)"
  [active]="!isInitialized"
  [fullscreen]="true"
></bc-atoms-loader>
<!-- EOF -->
